import React from "react";
import "./PANServices.css";
import { useNavigate } from "react-router-dom";
import { FcServices } from "react-icons/fc";

import aadharImg from "../assets/panno.jpg";
import panVerifyImg from "../assets/pande.png";
import panAdvanceImg from "../assets/panadvance.png"; // ⭐ apni image rakh dena

const services = [
  { 
    name: "Aadhar ➝ PAN Number", 
    img: aadharImg, 
    path: "/dashboard/aadhar-to-pan" 
  },
  { 
    name: "PAN Card Verify", 
    img: panVerifyImg, 
    path: "/dashboard/pan-verify" 
  },
  { 
    name: "PAN Advance", 
    img: panAdvanceImg, 
    path: "/dashboard/pan-advance"
  }
];

export default function PANServices() {

  const navigate = useNavigate();

  return (
    <div className="pan-services-wrapper">

      <h2 className="pan-title">
        <FcServices className="pan-icon" /> All PAN Related Services
      </h2>

      <div className="pan-divider"></div>

      <div className="pan-services-box">

        {services.map((item, i) => (
          <div className="pan-service-card" key={i}>
            
            <div
              className="pan-circle-box"
              onClick={() => navigate(item.path)}
            >
              <img src={item.img} alt={item.name} draggable="false" />
            </div>

            <p className="pan-service-name">{item.name}</p>

          </div>
        ))}

      </div>

    </div>
  );
}
